type ErrorListType = {
  [key: string]: string;
};

export const errorListTypes = {
  registrationError: 'registrationError',
  emailAlreadyExists: 'emailAlreadyExists',
  regitrationIdIsEmpty: 'regitrationIdIsEmpty',
  regitrationIdNotExist: 'regitrationIdNotExist',
  emailIsNotValid: 'emailIsNotValid',
  recaptchaResponseCodeDidNotPassValidation: 'recaptchaResponseCodeDidNotPassValidation',
  hasSuspendedPlan: 'hasSuspendedPlan',
  hasSubscriptionFound: 'hasSubscriptionFound',
  hasPlanAndNotPrimary: 'hasPlanAndNotPrimary'
};

export const errorList: ErrorListType = {
  'Registration error': 'registrationError',
  'Email already exist': 'emailAlreadyExists',
  'RegitrationId is Empty': 'regitrationIdIsEmpty',
  'RegitrationId not exist': 'regitrationIdNotExist',
  'Email is not valid': 'emailIsNotValid',
  'Recaptcha response code did not pass validation': 'recaptchaResponseCodeDidNotPassValidation',
  'Has suspended plan': 'hasSuspendedPlan',
  'Subscription already found': 'hasSubscriptionFound',
  'Has plan and not primary': 'hasPlanAndNotPrimary'
};
